import type React from 'react';

interface WarningIconProps {
  className?: string;
}

export const WarningIcon: React.FC<WarningIconProps> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M9 2.5L16.5 15.5H1.5L9 2.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9 7V10.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="9" cy="13" r="0.75" fill="currentColor" />
  </svg>
);
